import { render, staticRenderFns } from "./riderset.vue?vue&type=template&id=48f44a4c&scoped=true&"
import script from "./riderset.vue?vue&type=script&lang=js&"
export * from "./riderset.vue?vue&type=script&lang=js&"
import style0 from "./riderset.vue?vue&type=style&index=0&id=48f44a4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f44a4c",
  null
  
)

export default component.exports